
import { defineComponent, ref } from 'vue';

import { getParamObject } from '../utils/routing';
import { hexToRGB, getRandomHexColor } from '../utils/colors';
import { decimalToHex } from '../utils/numbers';

const red = ref(152);
const green = ref(129);
const blue = ref(123);

function colorPreviewStyle() {
	return `background-color: rgba(${red.value},${green.value},${blue.value},1)`;
}

function viewsParamObject() {
	return getParamObject<{ hex?: string; name?: string; tag?: string }>(
		window.location.search.slice(1)
	);
}

function assignHexToPath(hex: string) {
	window.location.search = `?hex=${hex.slice(1)}`;
}

function getHexFromPath() {
	const { hex } = viewsParamObject();

	if (hex != null) return hex;

	const randomHex = getRandomHexColor();

	assignHexToPath(randomHex);

	return randomHex;
}

function setup() {
	const hex = getHexFromPath();

	const rgb = hexToRGB(hex);
	if (rgb == null) return;

	red.value = rgb.r;
	green.value = rgb.g;
	blue.value = rgb.b;
}

function currentRGB() {
	return `${red.value},${green.value},${blue.value}`;
}

function currentHex() {
	const r = decimalToHex(red.value);
	const g = decimalToHex(green.value);
	const b = decimalToHex(blue.value);

	const hex = `#${r}${g}${b}`;
	return hex;
}

function currentName() {
	const { name } = viewsParamObject();
	return name;
}

function currentTag() {
	const { tag } = viewsParamObject();
	return tag;
}

async function copyEvent(text: string) {
	await navigator.clipboard.writeText(text);
}

async function hexPressEvent() {
	const hex = currentHex();
	await copyEvent(hex);
	return true;
}

async function rgbPressEvent() {
	const rgb = currentRGB();
	await copyEvent(rgb);
	return true;
}

export default defineComponent({
	name: 'EditScreen',
	computed: {
		colorPreviewStyle,
		currentRGB,
		currentHex,
		currentName,
		currentTag,
	},
	setup,
	emits: {
		hexPress: hexPressEvent,
		rgbPress: rgbPressEvent,
	},
});
